<template>
  <div>
    <data-list class="mt-3" :payload="listObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination">
      <v-container grid-list-xl slot="filterForm" class="pa-0">
        <v-layout row class="pb-3 px-3">
          <v-flex lg2 sm2 md2>
            <v-btn color="primary" @click="openDialogHandler">{{ $t('message.common.new') }}</v-btn>
          </v-flex>
          <v-flex lg2 sm3 md3 xs8>
            <v-autocomplete clearable v-model="filterObj.group_id" @change="getListHandler" autocomplete="off" :items="listOfProductGroups" :item-text="(x) => `${x.number ? x.number + ' - ' : '' } ${x.name}`" item-value="id" :label="$t('message.user.group')" dense hide-details outlined></v-autocomplete>
          </v-flex>
          <v-flex lg2 sm3 sm6 md3 xs12>
            <v-autocomplete clearable v-model="filterObj.supplier_id" @change="getListHandler" autocomplete="off" :items="listOfSuppliers" item-text="name" item-value="id" :label="$t('message.order.supplier')" dense hide-details outlined></v-autocomplete>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex lg4 sm4 md4 xs12 class="text-right">
            <v-text-field append-icon="search" outlined dense hide-details single-line v-model="search" :label="$t('message.common.search')" id="searchbtn"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </data-list>
    <v-dialog v-model="dialog" width="600" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference"></form-template>
    </v-dialog>
  </div>
</template>
<script>
import DataList from '@/components/DataList.vue'
import { mapState } from 'vuex'
import FormTemplate from '../../components/FormTemplate'
export default {
  data () {
    return {
      MODULE_URL: 'grossmargins',
      listObj: {
        isHeader: true,
        isHideAdd: true,
        hasFilters: true,
        selection: [],
        showSelect: true,
        list: [],
        loading: false,
        editProp: 'product_group_name',
        editHandler: this.getSingleRecordHandler
      },
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.GROSS_MARGIN_INDEX) ? this.$store.state.GROSS_MARGIN_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      filterObj: {
        supplier_id: 0,
        group_id: 0
      },
      search: '',
      dialog: false,
      modelObj: {}
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE', 'GROSS_MARGIN_INDEX', 'listOfSuppliers', 'listOfProductGroups']),
    headers () {
      return [{
        text: this.$t('message.layout.productGroup'),
        value: 'product_group_name',
        width: '35%'
      }, {
        text: `${this.$t('message.order.supplier')}`,
        value: 'customer_name',
        width: '35%'
      }, {
        text: `${this.$t('message.product.grossMargin')}`,
        value: 'gross_margin',
        width: '25%'
      }]
    },
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.priority.updatePriority') : this.$t('message.priority.addPriority'),
        properties: [{
          model: 'group_id',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfProductGroups,
          rules: this.$_requiredValidation,
          is_list: false,
          select_text: (x) => `${x.number ? x.number + ' - ' : ''} ${x.name}`,
          select_value: 'id',
          class: 'xs12',
          label: this.$t('message.layout.productGroup')
        }, {
          model: 'supplier_id',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfSuppliers,
          rules: this.$_requiredValidation,
          is_list: false,
          select_text: 'name',
          select_value: 'id',
          class: 'xs12',
          label: this.$t('message.order.supplier')
        }, {
          model: 'gross_margin',
          rules: this.$_norwegianNumberValidation,
          type: this.FORM_TYPE.TEXT,
          class: 'xs12',
          label: this.$t('message.product.grossMargin')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination (val) {
      const model = { type: 'GROSS_MARGIN_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    },
    search: function (newValue, oldValue) {
      this.getListHandler()
    }
  },
  mounted () {
    this.$store.dispatch('getSupplierList')
    this.$store.dispatch('getProductGroups')
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        const payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.listObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listObj.loading = true
      this.listObj.module = this.MODULE_URL
      const { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      const queryFields = ['group_id', 'supplier_id', 'gross_margin']
      const result = queryFields.find(x => x === sortBy[0])
      const pageVal = page || 1
      const query = {
        expand: [{
          model: 'ProductGroup',
          on_field: 'Id',
          on_parent_field: 'group_id',
          select: ['number', 'name'],
          filter: `name contains '${this.search || ''}' OR number contains '${this.search || ''}'`,
          order_by: {
            field: sortBy[0] === 'product_group_name' ? 'name' : null,
            asc_or_desc: sortBy[0] === 'product_group_name' ? sortDesc[0] ? 'desc' : 'asc' : null
          }
        }, {
          model: 'Customer',
          on_field: 'Id',
          on_parent_field: 'supplier_id',
          select: ['name'],
          filter: `name contains '${this.search || ''}'`,
          order_by: {
            field: sortBy[0] === 'customer_name' ? 'name' : null,
            asc_or_desc: sortBy[0] === 'customer_name' ? sortDesc[0] ? 'desc' : 'asc' : null
          }
        }],
        order_by: {
          field: result || null,
          asc_or_desc: sortDesc[0] ? 'desc' : 'asc'
        },
        skip: ((pageVal - 1) * itemsPerPage),
        limit: itemsPerPage,
        include_count: true,
        filter: `${queryFields.map(x => x).join(` contains '${this.search || ''}' OR `)} contains '${this.search || ''}'`
      }
      if (this.filterObj.group_id && !this.filterObj.supplier_id) query.additionalfilters = [`group_id eq ${this.filterObj.group_id}`]
      else if (!this.filterObj.group_id && this.filterObj.supplier_id) query.additionalfilters = [`supplier_id eq ${this.filterObj.supplier_id}`]
      else if (this.filterObj.group_id && this.filterObj.supplier_id) query.additionalfilters = [`group_id eq ${this.filterObj.group_id} AND supplier_id eq ${this.filterObj.supplier_id}`]
      this.$_executeApi('post', `${this.MODULE_URL}/query`, query).then(response => {
        const { values, count } = response.data
        this.listObj.loading = false
        const list = values.map(x => {
          x.gross_margin = this.$formatter.replaceDotWithComma(x.gross_margin)
          x.product_group_name = `${x.productgroup_number ? x.productgroup_number + ' - ' : ''} ${x.productgroup_name}`
          return x
        })
        this.listObj.list = list
        this.total = count
      })
    },
    getSingleRecordHandler (id) {
      this.$_getSingleRecordHandler(`${this.MODULE_URL}/${id}`)
        .then((result) => {
          if (result.data) {
            const model = result.data
            model.gross_margin = this.$formatter.replaceDotWithComma(model.gross_margin)
            this.modelObj = model
          }
          this.dialog = true
        })
    },
    openDialogHandler () {
      this.dialog = true
    },
    closeDialogHandler () {
      this.dialog = false
      this.modelObj.id = undefined
      this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.loading = true
        const model = this.modelObj
        model.gross_margin = this.$formatter.replaceCommaWithDot(model.gross_margin)
        const url = this.MODULE_URL
        this.$_saveUpdateHandler(url, model)
          .then(() => {
            this.closeDialogHandler()
            this.getListHandler()
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
